<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 bg-dark-blue">
          <img src="/img/arrow-left-white.svg" class="mt-4" height="30" @click="$router.back()" />
          <h5 class="text-center white bold mt-3 mb-5">Você sente que o projeto ajudou a reduzir seu sentimento de solidão?
          </h5>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12 col-sm-12">
          <h5 class="title dark-blue-normal">Em uma escala de 1 a 10:</h5>
          <div class="center-justifyed mt-3">
            <div :class="{ 'active': nenhum }" class="d-flex align-center" @click="toggleNenhum">
              <img src="img/emoji-triste.png" height="40" />
              <span class="ml-3 dark-blue-normal">0 = Nenhum</span>
            </div>
            <div :class="{ 'active': pouco }" class="d-flex mt-4 align-center" @click="togglePouco">
              <img src="img/emoji-chateado.png" height="40" />
              <span class="ml-3 dark-blue-normal">1 a 3 = Pouco</span>
            </div>
            <div :class="{ 'active': medio }" class="d-flex mt-4 align-center" @click="toggleMedio">
              <img src="img/emoji-neutro.png" height="40" />
              <span class="ml-3 dark-blue-normal">4 a 6 = Médio</span>
            </div>
            <div :class="{ 'active': muito }" class="d-flex mt-4 align-center" @click="toggleMuito">
              <img src="img/emoji-neutro-feliz.png" height="40" />
              <span class="ml-3 dark-blue-normal">7 a 9 = Muito</span>
            </div>
            <div :class="{ 'active': totalmente }" class="d-flex mt-4 align-center" @click="toggleTotalmente">
              <img src="img/emoji-feliz.png" height="40" />
              <span class="ml-3 dark-blue-normal">10 = Totalmente</span>
            </div>
          </div>
        </div>
        <div class="bottom">
          <button class="continue-btn" :disabled="loading" @click.prevent="handle">
            <span>CONTINUAR </span>
          </button>
        </div>
      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="required" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Escolha uma das opções</h5>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <Loading v-if="loading" />


  </div>
</template>

<script>

import api from "../axiosConfig";
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";
import config from "../config";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
  },
  data() {
    return {
      config,
      loading: false,
      nenhum: false,
      pouco: false,
      medio: false,
      muito: false,
      totalmente: false,
      descricao: undefined,
      idUsuario: undefined,
    };
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.$router.push("/login");
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    clearToggle() {
      this.nenhum = false;
      this.pouco = false;
      this.medio = false;
      this.muito = false;
      this.totalmente = false;
    },
    togglePouco() {
      this.clearToggle();
      this.pouco = true;
      this.descricao = '1 a 3 = Pouco';
    },
    toggleMedio() {
      this.clearToggle();
      this.medio = true;
      this.descricao = '4 a 6 = Médio';
    },
    toggleMuito() {
      this.clearToggle();
      this.muito = true;
      this.descricao = '7 a 9 = Muito';
    },
    toggleTotalmente() {
      this.clearToggle();
      this.totalmente = true;
      this.descricao = '10 = Totalmente';
    },
    toggleNenhum() {
      this.clearToggle();
      this.nenhum = true;
      this.descricao = '0 = Nenhum';
    },


    async handle() {
      if (!this.nenhum && !this.pouco && !this.medio && !this.muito && !this.totalmente) {
        return this.$refs.required.open();
      }

      await this.save();
    },

    async save() {
      try {
        this.loading = true;

        let descricao = this.descricao;

        var payload = {
          usuarioId: this.idUsuario,
          perguntaId: "0fc8c765-6766-4d31-b6f6-6ef2af5b7c63",
          descricao: descricao,
        };

        await api.post('/respostas', payload);

        this.loading = false;

        this.$router.push("/chat");
      } catch (error) {
        this.$refs.warning.open();
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.center-justifyed {
  display: flex;
  flex-direction: column;
  justify-self: anchor-center;
}

.text-center {
  text-align: center;
}

.active {
  padding: 8px;
  border: 1px solid #3BAED9;
  border-radius: 25px;
}
</style>
